Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Accordion2399262740",
  {"item":"Accordion2399262740--item","root":"Accordion2399262740--root"},
  ".Accordion2399262740--item{border-bottom:1px solid #dfe5eb;background-color:#fff}.Accordion2399262740--item[data-accordion2399262740-last]{border-bottom-width:0}",
  2,
  "Accordion2399262740"
);
__webpack_require__.stylable.$.register(exports.default)
